export {};
//# sourceMappingURL=IMetricTelemetry.js.map